module.exports = __webpack_public_path__ + "static/BannerContactUs-ec25669f65bdeb03549cc19a80dd00b6.png";